// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2026 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { spacing } from "~design-system";

export const QUESTIONNAIRE_FOOTER_HEIGHT = 80;

// The extra height the footer's error banner adds when it shows: the banner
// itself plus the gap above the buttons.
export const QUESTIONNAIRE_FOOTER_ERROR_HEIGHT = 64;

export const QUESTIONNAIRE_CONTENT_MAX_WIDTH = 600;

export const QUESTIONNAIRE_CONTENT_SIDE_PADDING = spacing.xl;
